import {Deserializable} from '../deserializable';


export  class VanBanDenFileXL implements Deserializable
{
  public  id: number;
  public  name: string;
  public  size: number;
  public  fileTypeID: number;
  public  maVB: number;
  public  fileKey: string;
  public  width: string;
  public  fileType: string;
  public folder: string;
  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
